import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export interface DeleteModalProps {
    title: string,
    context: string,
    deleteFunction: () => void;
    open: boolean,
    setOpen: (valor: boolean) => void
}

export const DeleteModal: React.FC<DeleteModalProps> = ({open, setOpen, deleteFunction, title, context}) => {

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {context}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancelar</Button>
                <Button onClick={() => {
                    deleteFunction();
                    setOpen(false);
                }} color="primary" variant="contained">
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}